import styled from 'styled-components'
import Icon from '@/components/common/Icon'
import SearchBarHeaderChips from '@/components/Ads/SearchBar/SearchBarHeaderChips'
import { getMappedSearchBarList } from '@/common/utils/transformFilters'
import { DEFAULT_FILTERS_MAP } from '@/common/constants/filtersFields'
import { device } from '@/common/constants/device'
import { useTranslations } from 'next-intl'

const SearchBarHeaderWrap = styled.div`
  position: relative;
  width: 100%;
`

const SearchBarHeaderField = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 52px;
  padding-right: 16px;
  border-radius: 12px;
  border: 1px solid var(--stroke);
  background-color: var(--white);
  cursor: pointer;
  transition: border-color 0.26s ease-in-out, background-color 0.26s ease-in-out;

  &:hover {
    background-color: var(--bright-gray);
    border-color: #bebebf;
  }

  @media ${device.tablet} {
    height: 48px;
  }
`

const SearchBarHeaderIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
`

const SearchBarHeaderPlaceholder = styled.div`
  font-size: 14px;
  line-height: 1.2em;
  font-weight: 500;
  color: var(--tertiary);

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 1.5em;
  }
`

const SearchBarHeader = ({ onClick, syncSearch, onFilterChange }) => {
  const t = useTranslations('ads')

  const onDelete = ({ filter, value, type }) => {
    const createdData = getMappedSearchBarList(syncSearch, DEFAULT_FILTERS_MAP)
    const newList = createdData[type].filter((item) => item !== value)

    onFilterChange({
      field: filter,
      value: {
        value: newList,
      },
      isUpdatedStructure: true,
    })
  }

  return Array.isArray(syncSearch) ? (
    <SearchBarHeaderWrap onClick={onClick}>
      <SearchBarHeaderField>
        <SearchBarHeaderIcon>
          <Icon size="20" icon="search-short" color="tertiary" />
        </SearchBarHeaderIcon>
        {syncSearch.length > 0 ? (
          <SearchBarHeaderChips onDelete={onDelete} chips={syncSearch} />
        ) : (
          <SearchBarHeaderPlaceholder>
            {t('searchCreativesPlaceholder')}
          </SearchBarHeaderPlaceholder>
        )}
      </SearchBarHeaderField>
    </SearchBarHeaderWrap>
  ) : null
}

export default SearchBarHeader
